"use client";

import useFlag from "~/hooks/useFlag";
import ReviewsRatingOld from "./ReviewsRatingOld";
import { TRUSTED_REVIEWS_COMPONENTS_VARIANT } from "~/constants/flags";
import ReviewsRatingNew from "./ReviewsRatingNew";

const ReviewsRating = () => {
    const isNewTrustedReviews = useFlag(TRUSTED_REVIEWS_COMPONENTS_VARIANT);

    if (isNewTrustedReviews) {
        return <ReviewsRatingNew />;
    }

    return <ReviewsRatingOld />;
};

export default ReviewsRating;